
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.889 5.637H6.11C5.497 5.637 5 6.134 5 6.748v7.778c0 .614.497 1.111 1.111 1.111h7.778c.614 0 1.111-.498 1.111-1.111V6.748c0-.614-.498-1.111-1.111-1.111z","stroke":"#000C1F","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.056 9.526a.833.833 0 100-1.667.833.833 0 000 1.667zM15 12.304v0a3.928 3.928 0 00-5.556 0l-3.333 3.333","stroke":"#000C1F","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    